export default "__VITE_ASSET__DHmIzMR4__"